import { Menubar, MenubarContent, MenubarMenu, MenubarTrigger } from "@components/common/menu-bar"
import useTranslator from "@hooks/use-translator"
import { cn } from "@pma/utils/helpers"
import { ReactElement, useRef } from "react"
import { Button } from "../common/button"

interface Props {
  children: ReactElement<any, any>
  title?: string
  message?: string
  onConfirm: (data?: any) => void
  confirmText?: string
  isSubmitting?: boolean
}
const ConfirmationMenu = ({
  children,
  title,
  message,
  onConfirm,
  confirmText,
  isSubmitting,
}: Props) => {
  const { translate } = useTranslator()
  const triggerRef = useRef<HTMLButtonElement>(null)
  return (
    <>
      <Menubar className='border-none bg-transparent'>
        <MenubarMenu>
          <MenubarTrigger
            ref={triggerRef}
            className={cn(
              "flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border p-0",
              "hover:bg-transparent",
            )}
          >
            {children}
          </MenubarTrigger>
          <MenubarContent className='mx-2 gap-2 bg-background'>
            <div className='p-3'>
              <div className='text-md font-semibold'>{title ?? translate("Proceed to change approval?")}</div>
              <div className='text-xs'>{message ?? translate("Are you sure to want a change approval?")}</div>
              <div className='mt-2 flex gap-1'>
                <Button
                  size={"sm"}
                  onClick={() => triggerRef.current?.blur()}
                  className='w-full md:w-32'
                  variant={"outline"}
                >
                  {translate("Cancel")}
                </Button>
                <Button
                  size={"sm"}
                  onClick={onConfirm}
                  className='w-full md:w-32'
                  loading={isSubmitting}
                  disabled={isSubmitting}
                >
                  {confirmText ?? translate("Change")}
                </Button>
              </div>
            </div>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
    </>
  )
}

export default ConfirmationMenu
